import React from 'react';

/**
 * A row of tabs with an underline under the selected one (the usual look of tabs in
 * office software). Each tab is { id, label, icon? }; `onChange` gets the tab id.
 */
const Tabs = ({ tabs, activeTab, onChange, className = '' }) => {
  return (
    <div role="tablist" className={`flex gap-1 border-b border-ui-line ${className}`}>
      {tabs.map((tab) => {
        const isActive = tab.id === activeTab;
        const Icon = tab.icon;
        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onChange(tab.id)}
            className={`-mb-px flex h-10 items-center gap-2 border-b-2 px-3 text-sm font-medium transition-colors ${
              isActive
                ? 'border-brand-500 text-ui-ink'
                : 'border-transparent text-ui-ink-3 hover:border-ui-line hover:text-ui-ink'
            }`}
          >
            {Icon && <Icon aria-hidden className={`size-4 ${isActive ? 'text-brand-600 dark:text-brand-300' : ''}`} />}
            {tab.label}
          </button>
        );
      })}
    </div>
  );
};

export default Tabs;
